import { render, staticRenderFns } from "./DelSysMessageAll.vue?vue&type=template&id=214ab9c6&scoped=true&"
import script from "./DelSysMessageAll.vue?vue&type=script&lang=js&"
export * from "./DelSysMessageAll.vue?vue&type=script&lang=js&"
import style0 from "./DelSysMessageAll.vue?vue&type=style&index=0&id=214ab9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ab9c6",
  null
  
)

export default component.exports